<template>
  <div class="travel-detail">
    <!-- 游记封面图像 -->
    <van-image ref="travelImg"
               fit="fill"
               height="190"
               :src="form.imgsCut ? form.imgsCut : form.imgs" />
    <!-- 游记标题 -->
    <div class="travel-title">
      <span class="travel-title-name">
        {{
        form.name && form.name.length > 20
        ? `${form.name.slice(0, 20)}...`
        : form.name
        }}
      </span>
      <span class="travel-title-time">发表时间：{{ form.updateTime | formatTime }}</span>
    </div>
    <!-- 游记作者 -->
    <div class="travel-author">
      <div class="travel-author-avatar">
        <van-image width="46"
                   height="46"
                   round
                   :src="form.avatar ? form.avatar :defaultAvatar" />
      </div>
      <div class="travel-author-info">
        <div class="travel_author_wrapper">
          <span class="travel-author-name">
            {{
            form.nickName
            ? form.nickName
            : `用户${form.userId}`
            }}
          </span>
          <div class="travel-author-related">
            <div class="collect-wrapper">
              <svg-icon iconClass="clollect"
                        class="icon-collect"></svg-icon>
              <span class="want-num">{{wantNum}}</span>
            </div>
            <div class="comment-wrapper">
              <svg-icon iconClass="comment"
                        class="icon-collect"></svg-icon>
              <span class="total-comment-num">{{totalCommentNum}}</span>
            </div>
          </div>
        </div>
        <div class="want_go_wrapper"
             @click="isHeart">
          <svg-icon :iconClass=" have == 0 || have == undefined ? 'want_go_no' : 'want_go_yes' "
                    class="icon_want_go"></svg-icon>
          <span class="text_want_go">我想去</span>
        </div>
      </div>
    </div>
    <!-- 游记属性 -->
    <div class="travel-attribute">
      <van-row class="travel-attribute-row">
        <div>
          <svg-icon iconClass="date"
                    class="icon-attribute"></svg-icon>
          <span>
            开始日期：{{
            form.beginDate ? form.beginDate : "--" | formatTime
            }}
          </span>
        </div>
        <div>
          <svg-icon iconClass="playDays"
                    class="icon-attribute"></svg-icon>
          <span>游玩天数：{{ form.playDays ? `${form.playDays}天` : "--" }}</span>
        </div>
      </van-row>
      <van-row class="travel-attribute-row">
        <div>
          <svg-icon iconClass="playWays"
                    class="icon-attribute"></svg-icon>
          <span>
            玩法：{{
            form.playTypeIdList ? form.playTypeIdList : "--" | getplayWay
            }}
          </span>
        </div>
      </van-row>
      <van-row class="travel-attribute-row">
        <div>
          <svg-icon iconClass="together"
                    class="icon-attribute"></svg-icon>
          <span>
            和谁去：{{
            form.tourPar ? form.tourPar : "--" | gettourPar
            }}
          </span>
        </div>
        <div>
          <svg-icon iconClass="consumption"
                    class="icon-attribute"></svg-icon>
          <span>人均消费：{{ form.price ? `${form.price}元` : "--" }}</span>
        </div>
      </van-row>
      <van-row class="travel-attribute-row">
        <div>
          <svg-icon iconClass="mileage"
                    class="icon-attribute"></svg-icon>
          <span>
            总里程数：{{
            form.totalMileage ? `${form.totalMileage}公里` : "--"
            }}
          </span>
        </div>
        <div>
          <svg-icon iconClass="driveDifficult"
                    class="icon-attribute"></svg-icon>
          <span>
            驾驶难度：{{
            form.difficulty ? form.difficulty : "--" | getdifficulty
            }}
          </span>
        </div>
      </van-row>
    </div>
    <!-- 游记正文 -->
    <div class="travel-container">
      <div class="travel-info">
        <template v-for="(items, index) in form.nodeList">
          <div class="info-level2"
               :ref="'node' + index"
               :key="`level-2-${index}`">
            <div class="info-content-level2">
              <div class="title-level2">
                <div class="round-circle"></div>
                <p class="monitorTarget">{{ items.name }}</p>
              </div>
              <template v-for="(itemschild, j) in items.paragraphList">
                <div class="info-content-level3"
                     :ref="'nodechild' + index + j"
                     :key="`level-3-${j}`">
                  <div class="level3-title"
                       v-if="itemschild.name">
                    <div class="round-circle"></div>
                    <span class="text-span monitorTarget">
                      {{
                      itemschild.name
                      }}
                    </span>
                  </div>
                  <template v-for="(itemschildchild, z) in itemschild.bodyList">
                    <div class="level3-content"
                         :key="`level-4-${z}`">
                      <div v-if="itemschildchild.type === 1">
                        <div class="content-item">
                          <van-image v-if="itemschildchild.content"
                                     :src="itemschildchild.content" />
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 2">
                        <div class="content-item">
                          <video v-if="itemschildchild.content"
                                 controls="controls"
                                 :src="itemschildchild.content"></video>
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 4">
                        <div class="content-item">
                          <p>{{ itemschildchild.content }}</p>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="text-end">
      <div class="text-end-top">本篇完</div>
      <div class="text-end-line"></div>
      <div class="text-end-bottom">自驾游，上鹿驾，出游更轻松！</div>
    </div>
    <!-- 发表评论 -->
    <div class="travel-commment"
         v-if="this.$cookie.get('userInfo_userId')">
      <van-field v-model="commentText"
                 rows="5"
                 type="textarea"
                 maxlength="512"
                 placeholder="友善的评论，良性的表达，用发现美的眼睛看世界。"
                 show-word-limit />
      <div class="travel-comment-tip">
        <span v-if="showTipText"
              class="travel-comment-text">说点儿什么再发表吧</span>
        <van-button class="travel-comment-release"
                    type="primary"
                    @click="releaseComment">发表评论</van-button>
      </div>
    </div>
    <!-- 热门游记 -->
    <div class="hot-comment-wrapper"
         v-if="hotCommentList.length > 0">
      <div class="hot-comment-btn">热门评论</div>
      <van-divider />
      <comment-card ref="comment"
                    class="comment-hot-list"
                    :List="hotCommentList"
                    @isreply="isreply"
                    @commentDelete="commentDelete"
                    @toggleLike="changeLike"
                    @replyRelease="replyRelease"></comment-card>
    </div>
    <!-- 所有评论 -->
    <div class="total-comment-wrapper"
         v-if="totalCommentList.length > 0">
      <van-divider>所有评论</van-divider>
    </div>
    <van-list v-if="totalCommentList.length > 0"
              v-model="infiniteLoading"
              :finished="showAllHasRead"
              finished-text="全部评论已读"
              @load="onLoad"
              :immediate-check="false"
              offset="50">
      <comment-card ref="comment"
                    class="comment-total-list"
                    :List="totalCommentList"
                    @isreply="isreply"
                    @commentDelete="commentDelete"
                    @toggleLike="changeLike"
                    @replyRelease="replyRelease"></comment-card>
    </van-list>
    <!-- 返回到顶部 -->
    <div v-if="showBackTop"
         @click="backToTopFun"
         class="back_top">
      <svg-icon iconClass="backtop"
                class="back_top_icon"></svg-icon>
    </div>
    <!-- 游记目录icon -->
    <div v-if="showCatlog"
         @click="showCatlogFun"
         class="travel_catlog">
      <svg-icon iconClass="menu"
                class="travel_catlog_icon"></svg-icon>
    </div>
    <!-- 游记目录内容 -->
    <div v-if="!showCatlog"
         class="travel_catlog_container">
      <div class="close_btn_wrapper">
        <van-icon name="cross"
                  @click="closeCatlogWrapper" />
      </div>
      <div class="travel-navi-content"
           ref="tNavi">
        <div class="navi-title">
          <p>目录导航</p>
        </div>
        <div class="navi-content no-shadow">
          <div class="navi-content-area">
            <template v-for="(items, index) in form.nodeList">
              <div class="navi-item naviTarget"
                   :key="`navi-${index}`"
                   v-if="items.name">
                <p class="left-line">
                  <span class="thin-line line-top"></span>
                  <span class="small-point"
                        :class="naviChecked == index ? 'checked-ball' : ''"></span>
                  <span class="thin-line line-bottom"></span>
                </p>
                <p class="item-text level2-navi-item"
                   :class="naviChecked == index ? 'checked-text' : ''"
                   @click="nodeClick($event, items, index)">{{ items.name }}</p>
              </div>
              <template v-for="(itemschild, j) in items.paragraphList">
                <div class="navi-item naviTarget"
                     v-if="itemschild.name && itemschild.name !== ''"
                     :key="`navi-line-${index}-${j}`">
                  <p class="left-line">
                    <span class="thin-line line-top"></span>
                    <span class="small-point"
                          :class="
                            naviChildChecked == `${index}${j}`
                              ? 'checked-ball'
                              : ''
                          "></span>
                    <span class="thin-line line-bottom"></span>
                  </p>
                  <p class="item-text level3-navi-item"
                     :class="
                          naviChildChecked == `${index}${j}`
                            ? 'checked-text'
                            : ''
                        "
                     @click="nodechildClick($event, index, j)">{{ itemschild.name }}</p>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Icon,
  Dialog,
  Image as VanImage,
  Row,
  Field,
  Button,
  Divider,
  List
} from "vant";
import CommonIcon from "@/components/icon/CommonIcon";
import CommentCard from "@/mobileCom/CommentCard";
//使用vant的懒加载
import { mapState, mapActions } from "vuex";
import heartOutLine from "@/assets/images/icons/icon-heart-outline.png";
import heart from "@/assets/images/icons/icon-heart.png";
import {
  saveComment,
  queryComment,
  adoptComment,
  replyComment,
  removeComment,
  filterComment,
  saveFeedback
} from "@/axios/service/travel";
import { mobileMsgErr, mobileMsgSuc } from "@/utils/MobileGlobal";
export default {
  name: "travel-detail",
  components: {
    [Icon.name]: Icon,
    [List.name]: List,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [Field.name]: Field,
    [Row.name]: Row,
    VanImage,
    CommonIcon,
    CommentCard
  },
  data () {
    return {
      naviChecked: "",
      naviChildChecked: "",
      heart: heart,
      heartOutLine: heartOutLine,
      showAllHasRead: false,
      infiniteLoading: false,
      commentText: "",
      totalCommentNum: 0,
      defaultAvatar: require("@/assets/images/person/avatar-default.png"),
      contentShow: false, //是否展示所有评论
      originRows: 20, //初始行数
      hasTriggerInfinate: false,
      form: {},
      travelId: "",
      showTipText: false,
      totalCommentList: [], //全部评论
      hotCommentList: [], //热门评论
      list: [],
      obj: {},
      showCatlog: true,
      showBackTop: false //初始不显示返回顶部
    };
  },
  computed: {
    ...mapState("NewTravelStore", ["findtreveldetail"]),
    ...mapState("CheckDataStore", ["wantNum", "have"])
  },
  watch: {
    "form.name" (value) {
      if (value) {
        document.title = `${value}_自驾出游好帮手_鹿驾网`;
        //form的值改变调用查询评论的接口
        this.queryComment({
          type: 1, //查询全部评论
          dataTypeId: 14,
          dataId: this.form.id,
          rows: this.hasTriggerInfinate ? this.originRows : 10, //是否出发过无限滚动，如果触发无限滚动则查询无限滚动那么多数据
          page: 1,
          userId: this.$cookie.get("userInfo_userId")
        });
        this.queryComment({
          type: 2, //查询热门评论
          dataTypeId: 14,
          dataId: this.form.id,
          rows: 3, //查询top3的热门评论
          page: 1,
          userId: this.$cookie.get("userInfo_userId")
        });
      }
    },
    findtreveldetail (value) {
      this.form = value[0];
    },
    hotCommentList (value) {
      if (value.length !== 0) {
        for (let i in value) {
          this.$set(value[i], "isreply", false);
          this.$set(value[i], "ishot", 1);
          for (let j in value[i].replys) {
            this.$set(value[i].replys[j], "isreply", false);
            this.$set(value[i].replys[j], "ishot", 1);
          }
        }
      }
    },
    totalCommentList (value) {
      if (value.length !== 0) {
        for (let i in value) {
          this.$set(value[i], "isreply", false);
          this.$set(value[i], "ishot", 0);
          for (let j in value[i].replys) {
            this.$set(value[i].replys[j], "isreply", false);
            this.$set(value[i].replys[j], "ishot", 0);
          }
        }
      }
    }
  },
  mounted () {
    // 切换页面时滚动条自动滚动到顶部
    window.scrollTo(0, this.$refs["travelImg"].$el.offsetTop);
    window.addEventListener("scroll", () => {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 0) {
        this.showBackTop = true;
      } else {
        //滚动到顶部的时候隐藏返回顶部的按钮
        this.showBackTop = false;
      }
    });
  },
  created () {
    this.travelId = this.$route.params.id;
    if (this.travelId.indexOf("old") !== -1) {
      //PC端
      this.travelId = this.travelId.substring(3, this.travelId.length);
      this.findTravelDetailOld({ id: this.travelId });
    } else if (this.travelId.indexOf("new") !== -1) {
      //PC端
      this.travelId = this.travelId.substring(3, this.travelId.length);
      this.findtrevelNotesdetail({ id: this.travelId });
    } else {
      //移动端
      this.findtrevelNotesdetail({ id: this.travelId });
    }
    this.getCheckWantgo({
      userId: this.$cookie.get("userInfo_userId"),
      dataId: this.travelId,
      dataTypeId: 14
    });
  },
  methods: {
    closeCatlogWrapper () {
      this.naviChildChecked = "~";
      this.naviChecked = "~";
      this.showCatlog = true;
    },
    nodeClick (e, items, index) {
      this.naviChildChecked = "~";
      this.naviChecked = index;
      window.scrollTo(0, this.$refs[`node${index}`][0].offsetTop);
    },
    nodechildClick (e, index, j) {
      this.naviChecked = "~";
      this.naviChildChecked = `${index}${j}`;
      window.scrollTo(0, this.$refs[`nodechild${index}${j}`][0].offsetTop);
    },
    showCatlogFun () {
      this.showCatlog = false;
    },
    backToTopFun () {
      window.scrollTo(0, 0);
      this.showBackTop = false;
    },
    isHeart () {
      let loginUserInfo = this.$cookie.get("userInfo_userId");
      //如果是已经登录状态则在想去和不想去之间尽心状态切换
      //如果是没有登录则跳转至登录页面
      if (loginUserInfo) {
        let data = {
          userId: this.$cookie.get("userInfo_userId"),
          dataId: this.travelId,
          dataTypeId: 14
        };
        if (this.have == 0) {
          this.getAddWantGo(data);
        } else if (this.have == 1) {
          this.getDeleteWantGo({
            data: [
              {
                userId: this.$cookie.get("userInfo_userId"),
                dataId: this.travelId,
                dataTypeId: 14
              }
            ]
          });
        }
      } else {
        //跳转至登录页
        this.$router.push({ path: `/login` });
      }
    },
    ...mapActions("CheckDataStore", [
      "getCheckWantgo",
      "getAddWantGo",
      "getDeleteWantGo"
    ]),
    ...mapActions("NewTravelStore", [
      "findtrevelNotesdetail",
      "findTravelDetailOld"
    ]),
    onLoad () {
      this.hasTriggerInfinate = true; //触发了无限滚动
      this.loadAllList();
    },
    loadAllList () {
      //查询全部评论列表
      //开启无限滚动loading
      this.infiniteLoading = true;
      this.queryComment(
        {
          type: 1, //查询所有评论
          dataTypeId: 14,
          dataId: this.form.id,
          rows: this.originRows,
          page: 1,
          userId: this.$cookie.get("userInfo_userId"),
          loadingFlase: true //禁止loading
        },
        "loadAllList"
      );
    },
    // 查询评论方法
    queryComment (queryForm, queryEntrance) {
      queryComment(queryForm).then(json => {
        if (json.respCode === 100) {
          if (queryForm.type == 1) {
            //检索全部评论
            this.lastTotal = json.data.length;
            this.totalCommentNum = json.total;
            let listTotal = json.total;
            if (listTotal > 0) {
              this.contentShow = true;
            } else {
              this.contentShow = false;
            }
            //如果是通过无限加载请求的查询
            if (queryEntrance === "loadAllList") {
              //关闭无限滚动loading
              this.infiniteLoading = false;
              this.originRows += 10; //每一次比上一次多查询10条数据
              this.totalCommentList = json.data;
              //用户请求的总的评论条数
              let DownloadTotal = queryForm.rows;
              if (DownloadTotal >= listTotal) {
                //已经没有更多数据的情况下: 显示所有评论已读，关闭无限滚动
                this.showAllHasRead = true;
              } else {
                this.showAllHasRead = false;
              }
            } else {
              //初始进入页面或者点赞等其他情况下的请求
              this.totalCommentList = json.data;
            }
          } else if (queryForm.type == 2) {
            //检索热门评论
            this.hotCommentList = json.data;
          }
        }
      });
    },
    searchCommentUtil () {
      //刷新热门评论
      this.queryComment({
        type: 2, //查询热门评论
        dataTypeId: 14,
        dataId: this.form.id,
        rows: 3, //查询top3的热门评论
        page: 1,
        userId: this.$cookie.get("userInfo_userId")
      });
      if (this.hasTriggerInfinate) {
        this.queryComment({
          type: 1, //查询全部评论
          dataTypeId: 14,
          dataId: this.form.id,
          rows: this.originRows + 1,
          page: 1,
          userId: this.$cookie.get("userInfo_userId")
        });
      } else {
        this.queryComment({
          type: 1, //查询全部评论
          dataTypeId: 14,
          dataId: this.form.id,
          rows: 10,
          page: 1,
          userId: this.$cookie.get("userInfo_userId")
        });
      }
    },
    //发表评论
    releaseComment () {
      let descrip = this.commentText.replace(/\n/g, "");
      //如果全是空格或者文本为空
      if (this.commentText.match(/^[ ]*$/) || !this.commentText) {
        this.showTipText = true;
        return;
      } else if (descrip.trim() == "") {
        this.showTipText = true;
        return;
      } else {
        saveComment({
          id: "",
          userId: this.$cookie.get("userInfo_userId"),
          state: 2,
          comment: this.commentText,
          dataTypeId: 14,
          dataType: 14,
          dataId: this.form.id,
          dataName: this.form.name,
          flag: 1,
          srcComment: ""
        }).then(json => {
          if (json.respCode === 100) {
            //清空上次评论的内容
            this.commentText = "";
            // 发表评论成功后刷新全部评论列表
            // 如果触发过无限搜索
            if (this.hasTriggerInfinate) {
              this.queryComment({
                type: 1, //查询全部评论
                dataTypeId: 14,
                dataId: this.form.id,
                rows: this.originRows + 1,
                page: 1,
                userId: this.$cookie.get("userInfo_userId")
              });
            } else {
              this.queryComment({
                type: 1, //查询全部评论
                dataTypeId: 14,
                dataId: this.form.id,
                rows: 10,
                page: 1,
                userId: this.$cookie.get("userInfo_userId")
              });
            }
          }
        });
      }
    },
    //是否点击回复按钮
    isreply (data) {
      if (this.$cookie.get("userInfo_userId")) {
        if (data.ishot === 1) {
          this.list = this.hotCommentList;
        } else {
          this.list = this.totalCommentList;
        }
        //首次打开弹出框
        if (data.childindex !== undefined) {
          for (var i = 0; i < this.list.length; i++) {
            this.list[i].isreply = false;
            if (this.list[i].replys) {
              for (var j = 0; j < this.list[i].replys.length; j++) {
                if (
                  data.index === i &&
                  data.childindex === j &&
                  !this.list[i].replys[j].isreply
                ) {
                  this.list[i].replys[j].isreply = true;
                } else {
                  this.list[i].replys[j].isreply = false;
                }
              }
            }
          }
        } else {
          for (var i = 0; i < this.list.length; i++) {
            if (data.index === i && !this.list[i].isreply) {
              this.list[i].isreply = true;
            } else {
              this.list[i].isreply = false;
            }
            if (this.list[i].replys) {
              for (var j = 0; j < this.list[i].replys.length; j++) {
                this.list[i].replys[j].isreply = false;
              }
            }
          }
        }
      } else {
        //跳转至登录页
        this.$router.push({ name: "login" });
      }
    },
    commentDelete (details) {
      let that = this;
      Dialog.confirm({
        title: "提示",
        message: `${
          details.childindex === undefined
            ? "删除评论，评论下全部回复内容将一并删除。"
            : "确定删除该条评论？"
          }`
      })
        .then(() => {
          removeComment({
            userId: that.$cookie.get("userInfo_userId"),
            id: details.item.id
          }).then(json => {
            //返回后查询所有数据
            if (json.respCode === 100) {
              this.searchCommentUtil();
            }
          });
        })
        .catch(() => { });
    },
    //更改点赞
    changeLike (details) {
      // 如果用户没有登录直接返回到登录页面
      if (this.$cookie.get("userInfo_userId")) {
        adoptComment({
          userId: this.$cookie.get("userInfo_userId"),
          commentId: details.item.id
        }).then(json => {
          //返回后查询所有数据
          if (json.respCode === 100) {
            this.searchCommentUtil();
          }
        });
      } else {
        //跳转至登录页
        this.$router.push({ name: "login" });
      }
    },
    //回复评论
    replyRelease (details) {
      if (details.flag === "1级") {
        this.obj = {
          dataTypeId: 14,
          dataId: this.travelId,
          dataName: this.form.name,
          comment: details.comment,
          userId: this.$cookie.get("userInfo_userId"),
          replyId: details.replyId,
          replyUserId: details.contents.userId,
          flag: 1
        };
      } else if (details.flag === "2级") {
        this.obj = {
          dataTypeId: 14,
          dataId: this.travelId,
          dataName: this.form.name,
          comment: details.comment,
          userId: this.$cookie.get("userInfo_userId"),
          replyId: details.contents.replyId,
          replyUserId: details.contents.userId,
          flag: 1
        };
      }
      replyComment(this.obj).then(json => {
        if (json.respCode === 100) {
          mobileMsgSuc("回复成功！");
          details.contents.isreply = false;
          this.searchCommentUtil();
        } else {
          mobileMsgErr("回复失败！");
        }
      });
    }
  },
  filters: {
    getdifficulty: function (value) {
      let levelMap = new Map([
        [1, "轻松"],
        [2, "适中"],
        [3, "困难"],
        ["--", "--"],
        [undefined, "--"]
      ]);

      return levelMap.get(value);
    },
    gettourPar: function (value) {
      let levelMap = new Map([
        [1, "独自一人"],
        [2, "好友"],
        [3, "亲子"],
        [4, "情侣"],
        [5, "闺蜜"],
        [6, "同学"],
        [7, "拼团"],
        [8, "家人"],
        ["--", "--"]
      ]);
      return levelMap.get(value);
    },
    getplayWay: function (value) {
      let levelMap = new Map([
        [1, "自然风光"],
        [2, "玩乐"],
        [3, "名胜古迹"],
        [4, "休闲区"],
        [5, "人文探索"],
        [6, "健康养生"]
      ]);
      let res = "";
      if (value === "--") {
        return "--";
      } else {
        if (value.length === 1) {
          return levelMap.get(value[0].typeId);
        } else {
          value.forEach((element, index) => {
            index === value.length - 1
              ? (res += levelMap.get(element.typeId))
              : (res += `${levelMap.get(element.typeId)}，`);
          });
        }
        return res;
      }
    },
    formatTime (value) {
      if (value && value !== "--") {
        return value.substring(0, value.indexOf(" "));
      } else {
        return "--";
      }
    }
  }
};
</script>
<style lang="less">
.travel-detail {
  display: flex;
  flex-direction: column;
  .travel-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 15px;
    padding-left: 16px;
    padding-bottom: 10px;
    box-shadow: 0px 0px 6px 0px rgba(221, 227, 240, 0.7);
    .travel-title-name {
      font-size: 17px;
      color: #333333;
    }
    .travel-title-time {
      margin-top: 12px;
      font-size: 13px;
      color: #999999;
    }
  }
  .travel-author {
    padding-top: 16px;
    padding-left: 16px;
    padding-right: 18px;
    display: flex;
    align-items: center;
    .travel-author-avatar {
      display: flex;
      align-items: center;
    }
    .travel-author-info {
      flex: 1;
      margin-left: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .travel-author-name {
        font-size: 14px;
        color: #ff8400;
      }
      .travel-author-related {
        display: flex;
        align-items: center;
        .comment-wrapper,
        .collect-wrapper {
          display: flex;
          align-items: center;
        }
        .comment-wrapper {
          margin-left: 20px;
        }
        .icon-collect {
          width: 12px;
          height: 12px;
        }
        .want-num,
        .total-comment-num {
          margin-left: 12px;
          font-size: 12px;
          color: #999999;
        }
      }
    }
    margin-bottom: 22px;
    .travel_author_wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }
    .want_go_wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      .icon_want_go {
        width: 25px;
        height: 25px;
      }
      .text_want_go {
        font-size: 12px;
        color: #333333;
      }
    }
  }
  .travel-attribute {
    margin: 0 auto;
    padding-left: 10px;
    padding-top: 16px;
    width: 345px;
    height: 146px;
    border: 1px dashed #e6e9ed;
    color: #999999;
    font-size: 13px;
    .travel-attribute-row {
      display: flex;
      justify-content: flex-start;
      div {
        margin-bottom: 16px;
        height: 15px;
        text-align: left;
        span {
          margin-left: 8px;
          font-size: 13px;
        }
      }
      //玩法那一行独占一行
      div:not(:only-child):nth-of-type(odd) {
        width: 55%;
      }
      div:not(:only-child):nth-of-type(even) {
        width: 45%;
      }
      .icon-attribute {
        width: 15px;
        height: 15px;
      }
    }
  }
  .travel-container {
    padding-left: 15px;
    padding-right: 15px;
    .travel-info {
      .round-circle {
        width: 4px;
        height: 4px;
        background-color: #34e4be;
        border-radius: 50%;
      }
      .title-level2,
      .level3-title {
        margin: 15px 0;
        text-align: left;
        display: flex;
        align-items: center;
        .monitorTarget {
          margin-left: 6px;
          font-size: 16px;
          color: #333333;
        }
      }
      .title-level2 {
        border-bottom: 1px solid #e6e9ed;
      }
      .content-item {
        p {
          margin: 15px 0;
          font-size: 14px;
          line-height: 19px;
          color: #333333;
          text-justify: inter-ideograph;
          text-align: justify;
          // text-align-last:left;
        }
      }
    }
  }
  .text-end {
    padding-left: 15px;
    padding-right: 15px;
    text-align: left;
    .text-end-top {
      color: #555555;
      font-size: 12px;
    }
    .text-end-line {
      margin: 5px 0px;
      height: 1px;
      border-top: 1px dashed #cacaca;
    }
    .text-end-bottom {
      color: #999999;
      font-size: 10px;
    }
  }
  .travel-commment {
    margin-top: 15px;
    padding-left: 15px;
    padding-right: 15px;
    .van-field {
      border-radius: 3px;
      border: 1px solid #e6e9ed;
    }
    .van-field__body {
      // padding: 12px 12px 0 12px;
      .van-field__control {
        height: 100px;
        color: #6d6d6d;
        font-size: 12px;
      }
    }
    .van-field__word-limit {
      padding-right: 12px;
    }
    .travel-comment-tip {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 12px;
      .travel-comment-text {
        font-size: 9px;
        color: #ff8400;
      }
      .travel-comment-release {
        margin-bottom: 10px;
        margin-left: 12px;
        .van-button__content {
          padding: 6px 20px;
          font-size: 9px;
        }
      }
    }
  }
  .hot-comment-wrapper {
    margin-top: 20px;
    padding-left: 15px;
    padding-right: 15px;
    .hot-comment-btn {
      margin-bottom: 11px;
      width: 77px;
      background-color: #ff8400;
      border-radius: 3px;
      padding: 4px 12px;
      font-size: 13px;
      color: #ffffff;
    }
  }
  .total-comment-wrapper {
    padding: 0 15px;
  }
  .comment-total-list {
    padding: 0 15px;
  }
  .back_top {
    position: fixed;
    bottom: 140px;
    right: 16px;
    .back_top_icon {
      height: 40px;
      width: 40px;
    }
  }
  .travel_catlog {
    position: fixed;
    bottom: 140px;
    left: 0px;
    .travel_catlog_icon {
      width: 54px;
      height: 40px;
    }
  }
  .travel_catlog_container {
    box-shadow: 0px 0px 6px 0px #dde3f0;
    position: fixed;
    left: 0px;
    bottom: 112px;
    padding-top: 14px;
    padding-left: 21px;
    padding-right: 15px;
    background-color: #ffffff;
    width: 260px;
    .close_btn_wrapper {
      height: 20px;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      text-align: right;
      .van-icon-cross {
        font-size: 13px;
      }
    }
    .travel-navi-content {
      .navi-title {
        font-size: 16px;
        color: #222222;
        line-height: 17px;
        p {
          margin: 15px 0;
          text-align: left;
        }
      }
      .navi-content {
        height: 371px;
        background-color: #ffffff;
        overflow-y: auto;
        .gray-bar {
          height: 26px;
          background-color: #f2f4f7;
        }
        .navi-content-area {
          text-align: left;
          height: 345px;
          overflow-x: hidden;
          overflow-y: auto;
          .navi-item {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            .left-line {
              width: 8px;
              margin: 0;
              margin-right: 15px;
              display: flex;
              flex-flow: column nowrap;
              align-items: stretch;
              .small-point {
                display: block;
                height: 7px;
                width: 7px;
                border-radius: 4px;
                margin: 1px 0;
                background: #dcdcdc;
              }
              .thin-line {
                display: block;
                width: 4px;
                box-sizing: border-box;
              }
              .line-top {
                display: block;
                height: 10px;
                border-right: 1px solid #dcdcdc;
              }
              .line-bottom {
                display: block;
                height: 9px;
                border-right: 1px solid #dcdcdc;
              }
            }
            &:first-child {
              .left-line {
                padding-top: 13px;
              }
              .line-top {
                height: 0px;
              }
              .line-bottom {
                height: 11px;
              }
            }
            &:last-child {
              .left-line {
                padding-bottom: 10px;
              }
              .line-top {
                height: 11px;
              }
              .line-bottom {
                height: 0px;
              }
            }

            .item-text {
              margin: 0;
              padding: 4px 0;
              font-size: 13px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer;
              &:hover {
                font-weight: 700;
                font-size: 14.5px;
              }
            }
            .level2-navi-item {
              color: #333333;
            }
            .level3-navi-item {
              color: #999999;
            }
            .checked-text {
              color: #57dec1;
            }
            .checked-ball {
              background: #57dec1 !important;
            }
          }
        }
      }
      .navi-footer {
        margin-top: 24px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        .navi-btn {
          width: 148px;
          height: 42px;
          line-height: 40px;
          border-radius: 4px;
          cursor: pointer;
          color: #ffffff;
          font-size: 18px;
        }
        .review {
          background: #57dec1;
        }
        .release {
          background: #fe9b01;
        }
      }
    }
  }
}
</style>
